import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@ordering/utils/styling';

const headerVariants = cva('font-heading tracking-[-0.22px]', {
  variants: {
    variant: {
      xs: 'text-[16px] leading-[22px]',
      s: 'text-[18px] leading-[22px]',
      mCustom: 'text-[22px] leading-[26px]',
      m: 'text-[24px] leading-[28px]',
      l: 'text-[32px] leading-[36px]',
    },
    weight: {
      regular: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    // see tailwind.config.js for exact weight
  },
  defaultVariants: {
    variant: 'm',
    weight: 'regular',
  },
});

export interface HeaderProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof headerVariants> {
  asChild?: boolean;
  as?: React.ElementType;
}

const Header = React.forwardRef<HTMLElement, HeaderProps>(
  ({ className, variant, weight, asChild = false, as = 'h1', children, ...props }, ref) => {
    const Comp = asChild ? Slot : as;

    return (
      <Comp className={cn(headerVariants({ variant, weight, className }))} ref={ref} {...props}>
        {children}
      </Comp>
    );
  }
);
Header.displayName = 'Header';

export { Header, headerVariants };
